import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const workflowViewKeyEnum = createEnum({
    CONTRACT_DETAIL: ['contract.detail', '合同详情', 'default'],
    CONTRACT_PAYMENT_DETAIL: ['contract.payment-detail', '付款详情', 'default'],
    CONTRACT_RECEIPT_DETAIL: ['contract.receipt-detail', '回款详情', 'default'],
    PURCHASE_REQUIREMENT_DETAIL: [
        'purchase-requirement.detail',
        '采购需求单详情',
        'default',
    ],
    PRE_RECEIVED_DEPOSIT_DETAIL: [
        'pre-received-deposit.detail',
        '预收定金详情',
        'default',
    ],
    PRE_RECEIVED_DEPOSIT_FUND_DETAIL: [
        'pre-received-deposit.fund-detail',
        '预收定金资金详情',
        'default',
    ],
    VEHICLE_INBOUND_DETAIL: ['vehicle-inbound.detail', '车辆入库详情', 'default'],
    VEHICLE_OUTBOUND_DETAIL: [
        'vehicle-outbound.detail',
        '车辆出库详情',
        'default',
    ],
    EXPORT_LICENSE_PROCESSING_DETAIL: [
        'export-license.processing-detail',
        '办理出口许可证',
        'default',
    ],
    CONTRACT_NEXT_STEP_TASK_DETAIL: [
        'contract.next-step-task-detail',
        '合同下一步任务办理',
        'default',
    ],
    PAYMENT_REQUEST_DETAIL: ['payment-request.detail', '付款申请详情', 'default'],
    RECEIPT_REQUEST_DETAIL: ['receipt-request.detail', '收款申请详情', 'default'],
    COUNTERPARTY_FUND_DETAIL: [
        'counterparty-fund.detail',
        '往来款详情',
        'default',
    ],
    COUNTERPARTY_FUND_OPERATION_DETAIL: [
        'counterparty-fund.operation-detail',
        '往来款操作详情',
        'default',
    ],
    SECURITY_DEPOSIT_PAYMENT_DETAIL: [
        'security-deposit-payment.detail',
        '支付保证金详情',
        'default',
    ],
    SECURITY_DEPOSIT_PAYMENT_OPERATION_DETAIL: [
        'security-deposit-payment.operation-detail',
        '支付保证金操作详情',
        'default',
    ],
    SECURITY_DEPOSIT_RECEIPT_DETAIL: [
        'security-deposit-receipt.detail',
        '收取保证金详情',
        'default',
    ],
    SECURITY_DEPOSIT_RECEIPT_OPERATION_DETAIL: [
        'security-deposit-receipt.operation-detail',
        '收取保证金操作详情',
        'default',
    ],
    INVOICE_APPLICATION_DETAIL: [
        'invoice-application.detail',
        '开票申请详情',
        'default',
    ],
});
export const WORKFLOW_VIEW_KEYS = enumValues(workflowViewKeyEnum);
export const WORKFLOW_VIEW_KEY_LABEL_MAP = enumLabelMap(workflowViewKeyEnum);
export const workflowDefinitionStatusEnum = createEnum({
    editing: ['editing', '草稿', 'default'],
    active: ['active', '已发布', 'green'],
    disabled: ['disabled', '已停用', 'red'],
});
export const WORKFLOW_DEFINITION_STATUSES = enumValues(workflowDefinitionStatusEnum);
export const WORKFLOW_DEFINITION_STATUS_LABEL_MAP = enumLabelMap(workflowDefinitionStatusEnum);
export const workflowInstanceStatusEnum = createEnum({
    running: ['running', '进行中', 'blue'],
    approved: ['approved', '已通过', 'green'],
    rejected: ['rejected', '已拒绝', 'red'],
    canceled: ['canceled', '已取消', 'default'],
    revoked: ['revoked', '已撤回', 'orange'],
});
export const WORKFLOW_INSTANCE_STATUSES = enumValues(workflowInstanceStatusEnum);
export const WORKFLOW_INSTANCE_STATUS_LABEL_MAP = enumLabelMap(workflowInstanceStatusEnum);
export const workflowTaskStatusEnum = createEnum({
    pending: ['pending', '待处理', 'orange'],
    approved: ['approved', '已通过', 'green'],
    rejected: ['rejected', '已拒绝', 'red'],
    transferred: ['transferred', '已转办', 'blue'],
    revoked: ['revoked', '已撤回', 'default'],
    canceled: ['canceled', '已取消', 'default'],
});
export const WORKFLOW_TASK_STATUSES = enumValues(workflowTaskStatusEnum);
export const WORKFLOW_TASK_STATUS_LABEL_MAP = enumLabelMap(workflowTaskStatusEnum);
export const workflowTaskActionEnum = createEnum({
    approve: ['approve', '审批通过', 'green'],
    reject: ['reject', '审批拒绝', 'red'],
    transfer: ['transfer', '转办', 'blue'],
    add_sign: ['add_sign', '加签', 'purple'],
    return_to: ['return_to', '退回', 'orange'],
    start: ['start', '发起', 'cyan'],
    revoke: ['revoke', '撤回', 'orange'],
    cc: ['cc', '抄送', 'geekblue'],
    system: ['system', '系统', 'default'],
});
export const WORKFLOW_TASK_ACTIONS = enumValues(workflowTaskActionEnum);
export const WORKFLOW_TASK_ACTION_LABEL_MAP = enumLabelMap(workflowTaskActionEnum);
export const workflowLogEventNameEnum = createEnum({
    WORKFLOW_STARTED: ['workflow.started', '发起流程', 'blue'],
    WORKFLOW_APPROVED: ['workflow.approved', '流程通过', 'green'],
    WORKFLOW_REJECTED: ['workflow.rejected', '流程拒绝', 'red'],
    WORKFLOW_REVOKED: ['workflow.revoked', '流程撤回', 'orange'],
    WORKFLOW_CANCELED: ['workflow.canceled', '流程作废', 'default'],
    WORKFLOW_TERMINATED: ['workflow.terminated', '流程终止', 'red'],
    WORKFLOW_TIMEOUT: ['workflow.timeout', '流程超期', 'red'],
    TASK_CREATED: ['task.created', '创建任务', 'blue'],
    TASK_APPROVED: ['task.approved', '审批通过', 'green'],
    TASK_REJECTED: ['task.rejected', '审批拒绝', 'red'],
    TASK_TRANSFERRED: ['task.transferred', '任务转办', 'purple'],
    TASK_RETURNED: ['task.returned', '退回节点', 'orange'],
    TASK_CANCELED: ['task.canceled', '任务取消', 'default'],
    TASK_REVOKED: ['task.revoked', '任务撤回', 'default'],
    TASK_EXPIRED: ['task.expired', '任务超时', 'red'],
    TASK_READ: ['task.read', '抄送已读', 'green'],
    NODE_APPROVED: ['node.approved', '节点通过', 'green'],
    NODE_REJECTED: ['node.rejected', '节点拒绝', 'red'],
    NODE_RETURNED: ['node.returned', '节点退回', 'orange'],
    NODE_SKIPPED: ['node.skipped', '节点跳过', 'default'],
    NODE_TIMEOUT: ['node.timeout', '节点超时', 'red'],
});
export const WORKFLOW_LOG_EVENT_NAMES = enumValues(workflowLogEventNameEnum);
export const WORKFLOW_LOG_EVENT_NAME_LABEL_MAP = enumLabelMap(workflowLogEventNameEnum);
export const workflowEventActionEventNameEnum = createEnum({
    WORKFLOW_STARTED: ['workflow.started', '流程发起', 'blue'],
    WORKFLOW_APPROVED: ['workflow.approved', '流程通过', 'green'],
    WORKFLOW_REJECTED: ['workflow.rejected', '流程拒绝', 'red'],
    WORKFLOW_REVOKED: ['workflow.revoked', '流程撤回', 'orange'],
    WORKFLOW_CANCELED: ['workflow.canceled', '流程作废', 'default'],
    WORKFLOW_TIMEOUT: ['workflow.timeout', '流程超期', 'red'],
    NODE_APPROVED: ['node.approved', '节点通过', 'green'],
    NODE_REJECTED: ['node.rejected', '节点拒绝', 'red'],
    NODE_RETURNED: ['node.returned', '节点退回', 'orange'],
    TASK_CREATED: ['task.created', '任务创建', 'blue'],
    TASK_APPROVED: ['task.approved', '任务通过', 'green'],
    TASK_REJECTED: ['task.rejected', '任务拒绝', 'red'],
    TASK_TRANSFERRED: ['task.transferred', '任务转办', 'purple'],
    TASK_CANCELED: ['task.canceled', '任务取消', 'default'],
    TASK_EXPIRED: ['task.expired', '任务超时', 'red'],
});
export const WORKFLOW_EVENT_ACTION_EVENT_NAMES = enumValues(workflowEventActionEventNameEnum);
export const WORKFLOW_EVENT_ACTION_EVENT_NAME_LABEL_MAP = enumLabelMap(workflowEventActionEventNameEnum);
export const workflowEventActionScopeEnum = createEnum({
    WORKFLOW: ['workflow', '流程', 'blue'],
    NODE: ['node', '节点', 'green'],
    TASK: ['task', '任务', 'purple'],
});
export const WORKFLOW_EVENT_ACTION_SCOPES = enumValues(workflowEventActionScopeEnum);
export const WORKFLOW_EVENT_ACTION_SCOPE_LABEL_MAP = enumLabelMap(workflowEventActionScopeEnum);
export const workflowEventActionTypeEnum = createEnum({
    INTERNAL_EVENT: ['internal_event', '内部事件', 'green'],
    HTTP_CALLBACK: ['http_callback', 'HTTP 回调', 'blue'],
    NOTIFICATION: ['notification', '站内通知', 'purple'],
    WEBHOOK: ['webhook', 'Webhook', 'cyan'],
});
export const WORKFLOW_EVENT_ACTION_TYPES = enumValues(workflowEventActionTypeEnum);
export const WORKFLOW_EVENT_ACTION_TYPE_LABEL_MAP = enumLabelMap(workflowEventActionTypeEnum);
export const workflowEventActionFailureStrategyEnum = createEnum({
    IGNORE: ['ignore', '忽略', 'default'],
    RETRY: ['retry', '重试', 'orange'],
    DEAD_LETTER: ['dead_letter', '死信', 'red'],
});
export const WORKFLOW_EVENT_ACTION_FAILURE_STRATEGIES = enumValues(workflowEventActionFailureStrategyEnum);
export const WORKFLOW_EVENT_ACTION_FAILURE_STRATEGY_LABEL_MAP = enumLabelMap(workflowEventActionFailureStrategyEnum);
//# sourceMappingURL=workflow.js.map